import { Component } from '@angular/core';
import { of, Observable, Subject } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { ICandidate } from '../../../interfaces/graph-types';
import { AccountService } from '../../../services/account.service';
import { WatchAccountService } from '../../../services/watch-account.service';
import { Router, ActivatedRoute } from '@angular/router';

class typeinfo {
  id?: string;
  name?: string;
  type?: string;
}

@Component({
  selector: '[account-search]',
  template: require('./account-search.component.pug'),
  styles: [require('./account-search.component.css').toString()],
})
export class AccountSearchComponent {
  asyncSelected: string;
  typeaheadLoading: boolean;
  typeaheadNoResults: boolean;
  dataSource: Observable<any>;
  statesComplex: any[] = [];

  searchResults: ICandidate[];

  candidateSubjectId: Subject<string>;

  isLoading = false;

  // -------------------------------------------------------------------
  constructor(
    private service: AccountService,
    private watch: WatchAccountService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.candidateSubjectId = new Subject<string>();
    this.dataSource = Observable.create((observer: any) => {
      // Runs on every search
      if (this.asyncSelected.toString().length > 0) {
        this.isLoading = true;
        this.service
          .searchAccountCandidates(
            watch.accountId().getValue(),
            this.asyncSelected.toString(),
          )
          .subscribe(response => {
            this.isLoading = false;
            this.searchResults = response;

            this.statesComplex = [];

            for (let i = 0; i < response.length; i++) {
              let p = response[i];
              let item = new typeinfo();
              item.id = p.id;
              item.name = p.name + ' (' + p.email + ')';
              item.type = 'candidate';
              this.statesComplex.push(item);
            }

            observer.next(this.asyncSelected);
          });
      }
    }).pipe(mergeMap((token: string) => this.getStatesAsObservable(token)));
  }

  // -------------------------------------------------------------------
  getAccountId() {
    return this.watch.accountId().getValue();
  }

  viewingCandidate: string;
  // -------------------------------------------------------------------
  selectCandidateInfo(candidate) {
    this.viewingCandidate = candidate.id;
    this.candidateSubjectId.next(candidate.id);
  }

  // -------------------------------------------------------------------
  closeCandidateInfo() {
    this.viewingCandidate = null;
  }

  // -------------------------------------------------------------------
  getStatesAsObservable(token: string): Observable<any> {
    //const query = new RegExp(token, 'ig');
    return of(
      this.statesComplex,

      /*.filter((state: any) => {
        return query.test(state.name);
      }),*/
    );
  }

  // -------------------------------------------------------------------
  changeTypeaheadLoading(e: boolean): void {
    this.typeaheadLoading = e;
  }

  // -------------------------------------------------------------------
  typeaheadOnSelect(e: any): void {
    //console.log('Selected value: ', e);
    this.candidateSubjectId.next(e.item.id);
    /*
    this.router.navigate(['candidates/details/' + e.item.id.toString()], {
      relativeTo: this.route,
    });
    */
    this.asyncSelected = '';
  }
}
